const MAIL_ENABLE_FAILURE_MESSAGE = "No se pudo habilitar el mail.";

const INACTIVE_CHAIN_MESSAGES = {
  responded: "La comunicación sigue inactiva porque el lead ya respondió.",
  no_active_templates:
    "La comunicación sigue inactiva porque el template group no tiene templates activos.",
};

const ENABLED_MAIL_FIELDS = ["rejected", "status", "send_number", "subject"];

export function mailNeedsEnabling(mailItem) {
  return (
    Boolean(mailItem?.rejected) ||
    Boolean(mailItem?.send_error) ||
    mailItem?.status === false
  );
}

export function buildEnabledMailChanges(result) {
  const changes = { send_error: null, send_error_date_approved: null };

  ENABLED_MAIL_FIELDS.forEach((field) => {
    if (result?.[field] !== undefined) {
      changes[field] = result[field];
    }
  });

  return changes;
}

export function getMailEnableWarning(result) {
  if (!result) return null;
  if (result.ok === false) return MAIL_ENABLE_FAILURE_MESSAGE;

  return INACTIVE_CHAIN_MESSAGES[result.reason] ?? null;
}

function pluralize(count, singular, plural) {
  return `${count} ${count === 1 ? singular : plural}`;
}

export function buildMailEnableSummaryWarning(results) {
  const safeResults = Array.isArray(results) ? results : [];
  const failedCount = safeResults.filter((result) => !result?.ok).length;
  const respondedCount = safeResults.filter(
    (result) => result?.ok && result.reason === "responded",
  ).length;
  const withoutTemplatesCount = safeResults.filter(
    (result) => result?.ok && result.reason === "no_active_templates",
  ).length;

  const sentences = [];

  if (failedCount > 0) {
    sentences.push(
      pluralize(
        failedCount,
        "mail no se pudo habilitar",
        "mails no se pudieron habilitar",
      ),
    );
  }

  const inactiveReasons = [];
  if (respondedCount > 0) {
    inactiveReasons.push(
      pluralize(respondedCount, "respondida por el lead", "respondidas por el lead"),
    );
  }
  if (withoutTemplatesCount > 0) {
    inactiveReasons.push(`${withoutTemplatesCount} sin templates activos`);
  }

  if (inactiveReasons.length > 0) {
    sentences.push(
      `${pluralize(
        respondedCount + withoutTemplatesCount,
        "comunicación sigue inactiva",
        "comunicaciones siguen inactivas",
      )}: ${inactiveReasons.join(", ")}`,
    );
  }

  return sentences.length > 0 ? `${sentences.join(". ")}.` : null;
}
